import { connect } from 'react-redux'

import {
    ActionIcon,
    Alert,
    Avatar,
    Collapse,
    Tooltip,
    Group,
    Loader,
    Menu,
    Indicator,
    Stack,
    Text,
    Flex
} from "@mantine/core";


let ChatMessage = (props) => {
    //console.log("ChatMessage", props.message.from.pseudo, props.message.from.online)
    if(props.message){ 
        return (
            <Group className='chat' align="flex-end">
                <Flex className={`${props.message.position}`} p={0} spacing={2} sx={{ maxWidth: "80%" }} align="flex-end">
                    <Tooltip label={props.message.from.pseudo} position={props.message.position}>
                        <Indicator
                                inline
                                size={12} // taille de la pastille
                                offset={4} // décalage par rapport à l’avatar
                                position="bottom-end"
                                color={props.message.from.online ? "green" : "gray"} // vert si online, gris sinon
                                withBorder
                            >
                            <Avatar size="sm" key={props.message.from.pseudo} name={props.message.from.pseudo} color="initials" src={props.message.from.avatar}>
                            </Avatar>
                        </Indicator>
                    </Tooltip>
                    <Stack p={0} spacing={0} m={0}>
                        <Text className='text' size="xs" align={"left"} p={0}>{props.message.text}</Text>
                    </Stack>
                </Flex>
            </Group>
        )
    } else {
        return ""
    }
}


const mapDispatchToProps = {
    
}


const mapStateToProps = (state) => {  
    return {
        notification: state ? state.notification : undefined,
        pathSelected: state.pathSelected
    }
}


ChatMessage = connect(mapStateToProps, mapDispatchToProps)(ChatMessage);

export default ChatMessage;